import slugify from "react-slugify";

import card0 from "../assets/cards/0.png";
import cardHalf0 from "../assets/cards/half/0.png";
import cardHalfFirst0 from "../assets/cards/half-first/0.png";
import cardQuarter0 from "../assets/cards/quarter/0.png";
import cardPreview0 from "../assets/cards/preview/0.png";
import card1 from "../assets/cards/1.png";
import cardHalf1 from "../assets/cards/half/1.png";
import cardHalfFirst1 from "../assets/cards/half-first/1.png";
import cardQuarter1 from "../assets/cards/quarter/1.png";
import cardPreview1 from "../assets/cards/preview/1.png";
import card2 from "../assets/cards/2.png";
import cardHalf2 from "../assets/cards/half/2.png";
import cardHalfFirst2 from "../assets/cards/half-first/2.png";
import cardQuarter2 from "../assets/cards/quarter/2.png";
import cardPreview2 from "../assets/cards/preview/2.png";
import card3 from "../assets/cards/3.png";
import cardHalf3 from "../assets/cards/half/3.png";
import cardHalfFirst3 from "../assets/cards/half-first/3.png";
import cardQuarter3 from "../assets/cards/quarter/3.png";
import cardPreview3 from "../assets/cards/preview/3.png";
import card4 from "../assets/cards/4.png";
import cardHalf4 from "../assets/cards/half/4.png";
import cardHalfFirst4 from "../assets/cards/half-first/4.png";
import cardQuarter4 from "../assets/cards/quarter/4.png";
import cardPreview4 from "../assets/cards/preview/4.png";
import card5 from "../assets/cards/5.png";
import cardHalf5 from "../assets/cards/half/5.png";
import cardHalfFirst5 from "../assets/cards/half-first/5.png";
import cardQuarter5 from "../assets/cards/quarter/5.png";
import cardPreview5 from "../assets/cards/preview/5.png";
import card6 from "../assets/cards/6.png";
import cardHalf6 from "../assets/cards/half/6.png";
import cardHalfFirst6 from "../assets/cards/half-first/6.png";
import cardQuarter6 from "../assets/cards/quarter/6.png";
import cardPreview6 from "../assets/cards/preview/6.png";
import card7 from "../assets/cards/7.png";
import cardHalf7 from "../assets/cards/half/7.png";
import cardHalfFirst7 from "../assets/cards/half-first/7.png";
import cardQuarter7 from "../assets/cards/quarter/7.png";
import cardPreview7 from "../assets/cards/preview/7.png";
import card8 from "../assets/cards/8.png";
import cardHalf8 from "../assets/cards/half/8.png";
import cardHalfFirst8 from "../assets/cards/half-first/8.png";
import cardQuarter8 from "../assets/cards/quarter/8.png";
import cardPreview8 from "../assets/cards/preview/8.png";
import card9 from "../assets/cards/9.png";
import cardHalf9 from "../assets/cards/half/9.png";
import cardHalfFirst9 from "../assets/cards/half-first/9.png";
import cardQuarter9 from "../assets/cards/quarter/9.png";
import cardPreview9 from "../assets/cards/preview/9.png";
import card10 from "../assets/cards/10.png";
import cardHalf10 from "../assets/cards/half/10.png";
import cardHalfFirst10 from "../assets/cards/half-first/10.png";
import cardQuarter10 from "../assets/cards/quarter/10.png";
import cardPreview10 from "../assets/cards/preview/10.png";
import card11 from "../assets/cards/11.png";
import cardHalf11 from "../assets/cards/half/11.png";
import cardHalfFirst11 from "../assets/cards/half-first/11.png";
import cardQuarter11 from "../assets/cards/quarter/11.png";
import cardPreview11 from "../assets/cards/preview/11.png";
import card12 from "../assets/cards/12.png";
import cardHalf12 from "../assets/cards/half/12.png";
import cardHalfFirst12 from "../assets/cards/half-first/12.png";
import cardQuarter12 from "../assets/cards/quarter/12.png";
import cardPreview12 from "../assets/cards/preview/12.png";
import card13 from "../assets/cards/13.png";
import cardHalf13 from "../assets/cards/half/13.png";
import cardHalfFirst13 from "../assets/cards/half-first/13.png";
import cardQuarter13 from "../assets/cards/quarter/13.png";
import cardPreview13 from "../assets/cards/preview/13.png";
import card14 from "../assets/cards/14.png";
import cardHalf14 from "../assets/cards/half/14.png";
import cardHalfFirst14 from "../assets/cards/half-first/14.png";
import cardQuarter14 from "../assets/cards/quarter/14.png";
import cardPreview14 from "../assets/cards/preview/14.png";
import card15 from "../assets/cards/15.png";
import cardHalf15 from "../assets/cards/half/15.png";
import cardHalfFirst15 from "../assets/cards/half-first/15.png";
import cardQuarter15 from "../assets/cards/quarter/15.png";
import cardPreview15 from "../assets/cards/preview/15.png";
import card16 from "../assets/cards/16.png";
import cardHalf16 from "../assets/cards/half/16.png";
import cardHalfFirst16 from "../assets/cards/half-first/16.png";
import cardQuarter16 from "../assets/cards/quarter/16.png";
import cardPreview16 from "../assets/cards/preview/16.png";
import card17 from "../assets/cards/17.png";
import cardHalf17 from "../assets/cards/half/17.png";
import cardHalfFirst17 from "../assets/cards/half-first/17.png";
import cardQuarter17 from "../assets/cards/quarter/17.png";
import cardPreview17 from "../assets/cards/preview/17.png";
import card18 from "../assets/cards/18.png";
import cardHalf18 from "../assets/cards/half/18.png";
import cardHalfFirst18 from "../assets/cards/half-first/18.png";
import cardQuarter18 from "../assets/cards/quarter/18.png";
import cardPreview18 from "../assets/cards/preview/18.png";
import card19 from "../assets/cards/19.png";
import cardHalf19 from "../assets/cards/half/19.png";
import cardHalfFirst19 from "../assets/cards/half-first/19.png";
import cardQuarter19 from "../assets/cards/quarter/19.png";
import cardPreview19 from "../assets/cards/preview/19.png";
import card20 from "../assets/cards/20.png";
import cardHalf20 from "../assets/cards/half/20.png";
import cardHalfFirst20 from "../assets/cards/half-first/20.png";
import cardQuarter20 from "../assets/cards/quarter/20.png";
import cardPreview20 from "../assets/cards/preview/20.png";
import card21 from "../assets/cards/21.png";
import cardHalf21 from "../assets/cards/half/21.png";
import cardHalfFirst21 from "../assets/cards/half-first/21.png";
import cardQuarter21 from "../assets/cards/quarter/21.png";
import cardPreview21 from "../assets/cards/preview/21.png";
import card22 from "../assets/cards/22.png";
import cardHalf22 from "../assets/cards/half/22.png";
import cardHalfFirst22 from "../assets/cards/half-first/22.png";
import cardQuarter22 from "../assets/cards/quarter/22.png";
import cardPreview22 from "../assets/cards/preview/22.png";
import card23 from "../assets/cards/23.png";
import cardHalf23 from "../assets/cards/half/23.png";
import cardHalfFirst23 from "../assets/cards/half-first/23.png";
import cardQuarter23 from "../assets/cards/quarter/23.png";
import cardPreview23 from "../assets/cards/preview/23.png";
import card24 from "../assets/cards/24.png";
import cardHalf24 from "../assets/cards/half/24.png";
import cardHalfFirst24 from "../assets/cards/half-first/24.png";
import cardQuarter24 from "../assets/cards/quarter/24.png";
import cardPreview24 from "../assets/cards/preview/24.png";
import card25 from "../assets/cards/25.png";
import cardHalf25 from "../assets/cards/half/25.png";
import cardHalfFirst25 from "../assets/cards/half-first/25.png";
import cardQuarter25 from "../assets/cards/quarter/25.png";
import cardPreview25 from "../assets/cards/preview/25.png";
import card26 from "../assets/cards/26.png";
import cardHalf26 from "../assets/cards/half/26.png";
import cardHalfFirst26 from "../assets/cards/half-first/26.png";
import cardQuarter26 from "../assets/cards/quarter/26.png";
import cardPreview26 from "../assets/cards/preview/26.png";
import card27 from "../assets/cards/27.png";
import cardHalf27 from "../assets/cards/half/27.png";
import cardHalfFirst27 from "../assets/cards/half-first/27.png";
import cardQuarter27 from "../assets/cards/quarter/27.png";
import cardPreview27 from "../assets/cards/preview/27.png";
import card28 from "../assets/cards/28.png";
import cardHalf28 from "../assets/cards/half/28.png";
import cardHalfFirst28 from "../assets/cards/half-first/28.png";
import cardQuarter28 from "../assets/cards/quarter/28.png";
import cardPreview28 from "../assets/cards/preview/28.png";
import card29 from "../assets/cards/29.png";
import cardHalf29 from "../assets/cards/half/29.png";
import cardHalfFirst29 from "../assets/cards/half-first/29.png";
import cardQuarter29 from "../assets/cards/quarter/29.png";
import cardPreview29 from "../assets/cards/preview/29.png";
import card30 from "../assets/cards/30.png";
import cardHalf30 from "../assets/cards/half/30.png";
import cardHalfFirst30 from "../assets/cards/half-first/30.png";
import cardQuarter30 from "../assets/cards/quarter/30.png";
import cardPreview30 from "../assets/cards/preview/30.png";
import card31 from "../assets/cards/31.png";
import cardHalf31 from "../assets/cards/half/31.png";
import cardHalfFirst31 from "../assets/cards/half-first/31.png";
import cardQuarter31 from "../assets/cards/quarter/31.png";
import cardPreview31 from "../assets/cards/preview/31.png";
import card32 from "../assets/cards/32.png";
import cardHalf32 from "../assets/cards/half/32.png";
import cardHalfFirst32 from "../assets/cards/half-first/32.png";
import cardQuarter32 from "../assets/cards/quarter/32.png";
import cardPreview32 from "../assets/cards/preview/32.png";
import card33 from "../assets/cards/33.png";
import cardHalf33 from "../assets/cards/half/33.png";
import cardHalfFirst33 from "../assets/cards/half-first/33.png";
import cardQuarter33 from "../assets/cards/quarter/33.png";
import cardPreview33 from "../assets/cards/preview/33.png";
import card34 from "../assets/cards/34.png";
import cardHalf34 from "../assets/cards/half/34.png";
import cardHalfFirst34 from "../assets/cards/half-first/34.png";
import cardQuarter34 from "../assets/cards/quarter/34.png";
import cardPreview34 from "../assets/cards/preview/34.png";
import card35 from "../assets/cards/35.png";
import cardHalf35 from "../assets/cards/half/35.png";
import cardHalfFirst35 from "../assets/cards/half-first/35.png";
import cardQuarter35 from "../assets/cards/quarter/35.png";
import cardPreview35 from "../assets/cards/preview/35.png";
import card36 from "../assets/cards/36.png";
import cardHalf36 from "../assets/cards/half/36.png";
import cardHalfFirst36 from "../assets/cards/half-first/36.png";
import cardQuarter36 from "../assets/cards/quarter/36.png";
import cardPreview36 from "../assets/cards/preview/36.png";
import card37 from "../assets/cards/37.png";
import cardHalf37 from "../assets/cards/half/37.png";
import cardHalfFirst37 from "../assets/cards/half-first/37.png";
import cardQuarter37 from "../assets/cards/quarter/37.png";
import cardPreview37 from "../assets/cards/preview/37.png";
import card38 from "../assets/cards/38.png";
import cardHalf38 from "../assets/cards/half/38.png";
import cardHalfFirst38 from "../assets/cards/half-first/38.png";
import cardQuarter38 from "../assets/cards/quarter/38.png";
import cardPreview38 from "../assets/cards/preview/38.png";
import card39 from "../assets/cards/39.png";
import cardHalf39 from "../assets/cards/half/39.png";
import cardHalfFirst39 from "../assets/cards/half-first/39.png";
import cardQuarter39 from "../assets/cards/quarter/39.png";
import cardPreview39 from "../assets/cards/preview/39.png";
import card40 from "../assets/cards/40.png";
import cardHalf40 from "../assets/cards/half/40.png";
import cardHalfFirst40 from "../assets/cards/half-first/40.png";
import cardQuarter40 from "../assets/cards/quarter/40.png";
import cardPreview40 from "../assets/cards/preview/40.png";
import card41 from "../assets/cards/41.png";
import cardHalf41 from "../assets/cards/half/41.png";
import cardHalfFirst41 from "../assets/cards/half-first/41.png";
import cardQuarter41 from "../assets/cards/quarter/41.png";
import cardPreview41 from "../assets/cards/preview/41.png";
import card42 from "../assets/cards/42.png";
import cardHalf42 from "../assets/cards/half/42.png";
import cardHalfFirst42 from "../assets/cards/half-first/42.png";
import cardQuarter42 from "../assets/cards/quarter/42.png";
import cardPreview42 from "../assets/cards/preview/42.png";
import card43 from "../assets/cards/43.png";
import cardHalf43 from "../assets/cards/half/43.png";
import cardHalfFirst43 from "../assets/cards/half-first/43.png";
import cardQuarter43 from "../assets/cards/quarter/43.png";
import cardPreview43 from "../assets/cards/preview/43.png";
import card44 from "../assets/cards/44.png";
import cardHalf44 from "../assets/cards/half/44.png";
import cardHalfFirst44 from "../assets/cards/half-first/44.png";
import cardQuarter44 from "../assets/cards/quarter/44.png";
import cardPreview44 from "../assets/cards/preview/44.png";
import card45 from "../assets/cards/45.png";
import cardHalf45 from "../assets/cards/half/45.png";
import cardHalfFirst45 from "../assets/cards/half-first/45.png";
import cardQuarter45 from "../assets/cards/quarter/45.png";
import cardPreview45 from "../assets/cards/preview/45.png";
import card46 from "../assets/cards/46.png";
import cardHalf46 from "../assets/cards/half/46.png";
import cardHalfFirst46 from "../assets/cards/half-first/46.png";
import cardQuarter46 from "../assets/cards/quarter/46.png";
import cardPreview46 from "../assets/cards/preview/46.png";
import card47 from "../assets/cards/47.png";
import cardHalf47 from "../assets/cards/half/47.png";
import cardHalfFirst47 from "../assets/cards/half-first/47.png";
import cardQuarter47 from "../assets/cards/quarter/47.png";
import cardPreview47 from "../assets/cards/preview/47.png";
import card48 from "../assets/cards/48.png";
import cardHalf48 from "../assets/cards/half/48.png";
import cardHalfFirst48 from "../assets/cards/half-first/48.png";
import cardQuarter48 from "../assets/cards/quarter/48.png";
import cardPreview48 from "../assets/cards/preview/48.png";
import card49 from "../assets/cards/49.png";
import cardHalf49 from "../assets/cards/half/49.png";
import cardHalfFirst49 from "../assets/cards/half-first/49.png";
import cardQuarter49 from "../assets/cards/quarter/49.png";
import cardPreview49 from "../assets/cards/preview/49.png";
import card50 from "../assets/cards/50.png";
import cardHalf50 from "../assets/cards/half/50.png";
import cardHalfFirst50 from "../assets/cards/half-first/50.png";
import cardQuarter50 from "../assets/cards/quarter/50.png";
import cardPreview50 from "../assets/cards/preview/50.png";
import card51 from "../assets/cards/51.png";
import cardHalf51 from "../assets/cards/half/51.png";
import cardHalfFirst51 from "../assets/cards/half-first/51.png";
import cardQuarter51 from "../assets/cards/quarter/51.png";
import cardPreview51 from "../assets/cards/preview/51.png";
import card52 from "../assets/cards/52.png";
import cardHalf52 from "../assets/cards/half/52.png";
import cardHalfFirst52 from "../assets/cards/half-first/52.png";
import cardQuarter52 from "../assets/cards/quarter/52.png";
import cardPreview52 from "../assets/cards/preview/52.png";

import cardUnknown from "../assets/cards/0.png";
import cardHalfUnknown from "../assets/cards/half/0.png";
import cardHalfFirstUnknown from "../assets/cards/half-first/0.png";
import cardQuarterUnknown from "../assets/cards/quarter/0.png";
import cardPreviewUnknown from "../assets/cards/preview/0.png";

import cardEmpty from "../assets/cards/empty.png";

import backgroundDark1 from "../assets/background-dark-1.jpg";
import backgroundDark2 from "../assets/background-dark-2.jpg";
import backgroundDark3 from "../assets/background-dark-3.jpg";
import backgroundLight1 from "../assets/background-light-1.jpg";
import backgroundLight2 from "../assets/background-light-2.jpg";
import backgroundLight3 from "../assets/background-light-3.jpg";
import backgroundLight4 from "../assets/background-light-4.jpg";

import table1 from "../assets/table-1.png";
import table2 from "../assets/table-2.png";
import table3 from "../assets/table-3.png";
import table4 from "../assets/table-4.png";
import table5 from "../assets/table-5.png";
import table6 from "../assets/table-6.png";
import table7 from "../assets/table-7.png";

import flopMP3 from "../assets/sounds/FLOP.mp3";
import turnMP3 from "../assets/sounds/TURN.mp3";
import riverMP3 from "../assets/sounds/RIVER.mp3";

import flopWAV from "../assets/sounds/FLOP.wav";
import turnWAV from "../assets/sounds/TURN.wav";
import riverWAV from "../assets/sounds/RIVER.wav";

import checkMP3 from "../assets/sounds/CHECK.mp3";
import checkWAV from "../assets/sounds/CHECK.wav";

import callMP3 from "../assets/sounds/CALL.mp3";
import callWAV from "../assets/sounds/CALL.wav";

import betMP3 from "../assets/sounds/BET.mp3";
import betWAV from "../assets/sounds/BET.wav";

import raiseMP3 from "../assets/sounds/RAISE.mp3";
import raiseWAV from "../assets/sounds/RAISE.wav";

import collectMP3 from "../assets/sounds/COLLECT.mp3";
import collectWAV from "../assets/sounds/COLLECT.wav";

import pokerstarsIcon from "../assets/rooms/POKERSTARS.png";
import fulltiltIcon from "../assets/rooms/FULLTILT.png";
import everestIcon from "../assets/rooms/EVEREST_BETCLIC_FR.png";
import partygamingIcon from "../assets/rooms/PARTYGAMING.png";
import winamaxIcon from "../assets/rooms/WINAMAX.png";
import ongameIcon from "../assets/rooms/ONGAME.png";
import barriereIcon from "../assets/rooms/BARRIERE.png";
import partoucheIcon from "../assets/rooms/BARRIERE.png";
import network888Icon from "../assets/rooms/NETWORK_888.png";
import peoplesNetworkIcon from "../assets/rooms/PEOPLES_NETWORK.png";
import cakePokerIcon from "../assets/rooms/CAKE_POKER.png";
import igamingIcon from "../assets/rooms/IGAMING.png";
import ggPokerIcon from "../assets/rooms/GGPOKER.png";

import vote0Icon from "../assets/emoticons/vote0.png";
import vote0IconDisabled from "../assets/emoticons/vote0-disabled.png";
import vote1Icon from "../assets/emoticons/vote1.png";
import vote1IconDisabled from "../assets/emoticons/vote1-disabled.png";
import vote2Icon from "../assets/emoticons/vote2.png";
import vote2IconDisabled from "../assets/emoticons/vote2-disabled.png";
import vote3Icon from "../assets/emoticons/vote3.png";
import vote3IconDisabled from "../assets/emoticons/vote3-disabled.png";
import vote4Icon from "../assets/emoticons/vote4.png";
import vote4IconDisabled from "../assets/emoticons/vote4-disabled.png";

import avatarA from "../assets/avatars/a.png";
import avatarZ from "../assets/avatars/z.png";
import avatarE from "../assets/avatars/e.png";
import avatarR from "../assets/avatars/r.png";
import avatarT from "../assets/avatars/t.png";
import avatarY from "../assets/avatars/y.png";
import avatarU from "../assets/avatars/u.png";
import avatarI from "../assets/avatars/i.png";
import avatarO from "../assets/avatars/o.png";
import avatarP from "../assets/avatars/p.png";
import avatarQ from "../assets/avatars/q.png";
import avatarS from "../assets/avatars/s.png";
import avatarD from "../assets/avatars/d.png";
import avatarF from "../assets/avatars/f.png";
import avatarG from "../assets/avatars/g.png";
import avatarH from "../assets/avatars/h.png";
import avatarJ from "../assets/avatars/j.png";
import avatarK from "../assets/avatars/k.png";
import avatarL from "../assets/avatars/l.png";
import avatarM from "../assets/avatars/m.png";
import avatarW from "../assets/avatars/w.png";
import avatarX from "../assets/avatars/x.png";
import avatarC from "../assets/avatars/c.png";
import avatarV from "../assets/avatars/v.png";
import avatarB from "../assets/avatars/b.png";
import avatarN from "../assets/avatars/n.png";

import languageFR from "../assets/languages/fr.gif";
import languageEN from "../assets/languages/en.gif";
import languageIT from "../assets/languages/it.gif";
import languagePT from "../assets/languages/pt.gif";

import specialty0Icon from "../assets/specialty/1.png";
import specialty1Icon from "../assets/specialty/1.png";
import specialty2Icon from "../assets/specialty/2.png";
import specialty3Icon from "../assets/specialty/3.png";
import specialty4Icon from "../assets/specialty/4.png";
import specialty5Icon from "../assets/specialty/5.png";
import specialty6Icon from "../assets/specialty/6.png";
import specialty7Icon from "../assets/specialty/7.png";
import specialty8Icon from "../assets/specialty/8.png";
import specialty9Icon from "../assets/specialty/9.png";
import specialty10Icon from "../assets/specialty/10.png";
import specialty11Icon from "../assets/specialty/11.png";
import specialty12Icon from "../assets/specialty/12.png";
import specialty13Icon from "../assets/specialty/13.png";
import specialty14Icon from "../assets/specialty/14.png";
import specialty15Icon from "../assets/specialty/15.png";

import variant1Icon from "../assets/variant/1.png";
import variant2Icon from "../assets/variant/2.png";
import variant3Icon from "../assets/variant/3.png";
import variant4Icon from "../assets/variant/4.png";
import variant5Icon from "../assets/variant/5.png";

import structure0Icon from "../assets/structure/0.png";
import structure1Icon from "../assets/structure/1.png";
import structure2Icon from "../assets/structure/2.png";
import structure3Icon from "../assets/structure/3.png";
import structure4Icon from "../assets/structure/4.png";
import structure5Icon from "../assets/structure/5.png";

const isDevReact = () => {
  return false;
};

const assets = {
  table1: table1,
  table2: table2,
  table3: table3,
  table4: table4,
  table5: table5,
  table6: table6,
  table7: table7,
  backgroundDark1: backgroundDark1,
  backgroundDark2: backgroundDark2,
  backgroundDark3: backgroundDark3,
  backgroundLight1: backgroundLight1,
  backgroundLight2: backgroundLight2,
  backgroundLight3: backgroundLight3,
  backgroundLight4: backgroundLight4
};

const soundValues = [];
soundValues.push(flopMP3);
soundValues.push(flopWAV);
soundValues.push(turnMP3);
soundValues.push(turnWAV);
soundValues.push(riverMP3);
soundValues.push(riverWAV);
soundValues.push(checkMP3);
soundValues.push(checkWAV);
soundValues.push(callMP3);
soundValues.push(callWAV);
soundValues.push(betMP3);
soundValues.push(betWAV);
soundValues.push(raiseMP3);
soundValues.push(raiseWAV);
soundValues.push(collectMP3);
soundValues.push(collectWAV);

const AspectRatio = {
  refWidth: 794,
  refHeight: 529,
  refFontSize: 12,
  refLineHeight: 18,
  refCheckboxWidth: 8,
  refHeaderPadding: 5,
  refButtonMargin: 12,
  maxRefButtonMargin: 18,
  refShadowSize: 7,
  refChipsBorderWidth: 2,
  refPlayerWidth: 115,
  refBoardPotMargin: 10,

  refCardHalfWidth: 45,
  refCardHalfHeightRatio: 0.796875,

  refBoardCardWidth: 50,
  refBoardCardHeightRatio: 1.3828125,
  refBoardCardMargin: 3.5,

  refCardQuarterWidth: 19.3125,

  refChipsLabelWidth: 75,
  refChipsLabelTextWidth: 50,

  refActionsMargin: 4,

  refPlayerRadius: 4,

  getSliderSize: (ratio) => {
    if (ratio < 1) {
      return "sm";
    } else {
      return "lg";
    }
  }
};

const SessionType = {
  TOURNAMENT: 1,
  CASHGAME: 2
};

const GameSpecialty = {
  UNKNOWN: 0,
  FREEZEOUT_TYPE: 1,
  REBUY_TYPE: 2,
  SHOOTOUT_TYPE: 3,
  KNOCKOUT_TYPE: 4,
  SAT_FREEZEOUT_TYPE: 5,
  SAT_REBUY_TYPE: 6,
  SAT_SHOOTOUT_TYPE: 7,
  SAT_KNOCKOUT_TYPE: 8,
  NORMAL_CG_TYPE: 9,
  FAST_FOLD_CG_TYPE: 10,
  ANTE_CG_TYPE: 11,
  JACKPOT_TYPE: 12,
  DON_TYPE: 13,
  STEPS_TYPE: 14,
  REENTRY_TYPE: 15
};
const GameSpecialtyIcons = {
  UNKNOWN: specialty0Icon,
  FREEZEOUT_TYPE: specialty1Icon,
  REBUY_TYPE: specialty2Icon,
  SHOOTOUT_TYPE: specialty3Icon,
  KNOCKOUT_TYPE: specialty4Icon,
  SAT_FREEZEOUT_TYPE: specialty5Icon,
  SAT_REBUY_TYPE: specialty6Icon,
  SAT_SHOOTOUT_TYPE: specialty7Icon,
  SAT_KNOCKOUT_TYPE: specialty8Icon,
  NORMAL_CG_TYPE: specialty9Icon,
  FAST_FOLD_CG_TYPE: specialty10Icon,
  ANTE_CG_TYPE: specialty11Icon,
  JACKPOT_TYPE: specialty12Icon,
  DON_TYPE: specialty13Icon,
  STEPS_TYPE: specialty14Icon,
  REENTRY_TYPE: specialty15Icon
};

const GameStructure = {
  UNKNOWN: 0,
  NORMAL: 1,
  TURBO: 2,
  SUPERTURBO: 3,
  DEEP: 4
};
const GameStructureIcons = {
  0: structure0Icon,
  1: structure1Icon,
  2: structure2Icon,
  3: structure3Icon,
  4: structure4Icon,
  5: structure5Icon,
};

const GameVariant = {
  NO_LIMIT_HOLD_EM: 1,
  LIMIT_HOLD_EM: 2,
  POT_LIMIT_HOLD_EM: 3,
  LIMIT_OMAHA: 4,
  POT_LIMIT_OMAHA: 5,
  OTHER_VARIANT: 6
};
const GameVariantIcons = {
  NO_LIMIT_HOLD_EM: variant1Icon,
  LIMIT_HOLD_EM: variant2Icon,
  POT_LIMIT_HOLD_EM: variant3Icon,
  LIMIT_OMAHA: variant4Icon,
  POT_LIMIT_OMAHA: variant5Icon,
};

const Step = {
  NONE: "NONE",
  FLOP: "FLOP",
  TURN: "TURN",
  RIVER: "RIVER",
  SHOWDOWN: "SHOWDOWN",
  SUMMARY: "SUMMARY",
  INIT: "INIT"
};

const HandEventType = {
  // STEP ACTION
  NONE: "NONE",
  FOLD: "FOLD",
  CHECK: "CHECK",
  CALL: "CALL",
  BET: "BET",
  RAISE: "RAISE",
  UNCALLED_BET: "UNCALLED_BET",

  // INIT ACTION
  POSTS_SB: "POSTS_SB",
  POSTS_BB: "POSTS_BB",
  POSTS_ANTE: "POSTS_ANTE",
  POSTS_DEAD_BB: "POSTS_DEAD_BB",

  // SUMMARY ACTION
  COLLECT: "COLLECT",
  WON_HAND: "WON_HAND",
  FINISH: "FINISH",
  WIN_BOUNTY: "WIN_BOUNTY",
  REBUY: "REBUY",
  DOUBLE_REBUY: "DOUBLE_REBUY",
  SAID: "SAID",

  // SHOWDOWN
  SHOW: "SHOW",
  MUCK: "MUCK",
  REALLYMUCK: "REALLYMUCK",
  AT_SHOWDOWN: "AT_SHOWDOWN",

  // USELESS ACTION
  DECONNECT: "DECONNECT",
  RECONNECT: "RECONNECT",
  TANK: "TANK",
  SITOUT: "SITOUT",
  SITIN: "SITIN",
  STEP: "STEP"
};

const ReplayerPreferredSeats = {
  seats2: 1,
  seats3: 2,
  seats4: 2,
  seats5: 3,
  seats6: 3,
  seats7: 4,
  seats8: 4,
  seats9: 5,
  seats10: 5
};

const getCardText = (num) => {
  if (num <= 0) {
    return "?";
  }
  let value = num % 13;
  switch (value) {
    case 1: {
      return "2";
    }
    case 2: {
      return "3";
    }
    case 3: {
      return "4";
    }
    case 4: {
      return "5";
    }
    case 5: {
      return "6";
    }
    case 6: {
      return "7";
    }
    case 7: {
      return "8";
    }
    case 8: {
      return "9";
    }
    case 9: {
      return "T";
    }
    case 10: {
      return "J";
    }
    case 11: {
      return "Q";
    }
    case 12: {
      return "K";
    }
    default: {
      return "A";
    }
  }
}
const CLUBS_COLOR = "clubs";
const SPADES_COLOR = "spades";
const HEARTS_COLOR = "hearts";
const DIAMONDS_COLOR = "diamonds";

const getCardColor = (num) => {
  if (num >= 1 && num <= 13) {
    return CLUBS_COLOR;
  }
  else if (num >= 14 && num <= 26) {
    return SPADES_COLOR;
  }
  else if (num >= 27 && num <= 39) {
    return HEARTS_COLOR;
  }
  else if (num >= 40 && num <= 52) {
    return DIAMONDS_COLOR;
  } else {
    return SPADES_COLOR;
  }
}

const Cards = {
  card0: card0,
  cardHalf0: cardHalf0,
  cardHalfFirst0: cardHalfFirst0,
  cardQuarter0: cardQuarter0,
  cardPreview0: cardPreview0,
  card1: card1,
  cardHalf1: cardHalf1,
  cardHalfFirst1: cardHalfFirst1,
  cardQuarter1: cardQuarter1,
  cardPreview1: cardPreview1,
  card2: card2,
  cardHalf2: cardHalf2,
  cardHalfFirst2: cardHalfFirst2,
  cardQuarter2: cardQuarter2,
  cardPreview2: cardPreview2,
  card3: card3,
  cardHalf3: cardHalf3,
  cardHalfFirst3: cardHalfFirst3,
  cardQuarter3: cardQuarter3,
  cardPreview3: cardPreview3,
  card4: card4,
  cardHalf4: cardHalf4,
  cardHalfFirst4: cardHalfFirst4,
  cardQuarter4: cardQuarter4,
  cardPreview4: cardPreview4,
  card5: card5,
  cardHalf5: cardHalf5,
  cardHalfFirst5: cardHalfFirst5,
  cardQuarter5: cardQuarter5,
  cardPreview5: cardPreview5,
  card6: card6,
  cardHalf6: cardHalf6,
  cardHalfFirst6: cardHalfFirst6,
  cardQuarter6: cardQuarter6,
  cardPreview6: cardPreview6,
  card7: card7,
  cardHalf7: cardHalf7,
  cardHalfFirst7: cardHalfFirst7,
  cardQuarter7: cardQuarter7,
  cardPreview7: cardPreview7,
  card8: card8,
  cardHalf8: cardHalf8,
  cardHalfFirst8: cardHalfFirst8,
  cardQuarter8: cardQuarter8,
  cardPreview8: cardPreview8,
  card9: card9,
  cardHalf9: cardHalf9,
  cardHalfFirst9: cardHalfFirst9,
  cardQuarter9: cardQuarter9,
  cardPreview9: cardPreview9,
  card10: card10,
  cardHalf10: cardHalf10,
  cardHalfFirst10: cardHalfFirst10,
  cardQuarter10: cardQuarter10,
  cardPreview10: cardPreview10,
  card11: card11,
  cardHalf11: cardHalf11,
  cardHalfFirst11: cardHalfFirst11,
  cardQuarter11: cardQuarter11,
  cardPreview11: cardPreview11,
  card12: card12,
  cardHalf12: cardHalf12,
  cardHalfFirst12: cardHalfFirst12,
  cardQuarter12: cardQuarter12,
  cardPreview12: cardPreview12,
  card13: card13,
  cardHalf13: cardHalf13,
  cardHalfFirst13: cardHalfFirst13,
  cardQuarter13: cardQuarter13,
  cardPreview13: cardPreview13,
  card14: card14,
  cardHalf14: cardHalf14,
  cardHalfFirst14: cardHalfFirst14,
  cardQuarter14: cardQuarter14,
  cardPreview14: cardPreview14,
  card15: card15,
  cardHalf15: cardHalf15,
  cardHalfFirst15: cardHalfFirst15,
  cardQuarter15: cardQuarter15,
  cardPreview15: cardPreview15,
  card16: card16,
  cardHalf16: cardHalf16,
  cardHalfFirst16: cardHalfFirst16,
  cardQuarter16: cardQuarter16,
  cardPreview16: cardPreview16,
  card17: card17,
  cardHalf17: cardHalf17,
  cardHalfFirst17: cardHalfFirst17,
  cardQuarter17: cardQuarter17,
  cardPreview17: cardPreview17,
  card18: card18,
  cardHalf18: cardHalf18,
  cardHalfFirst18: cardHalfFirst18,
  cardQuarter18: cardQuarter18,
  cardPreview18: cardPreview18,
  card19: card19,
  cardHalf19: cardHalf19,
  cardHalfFirst19: cardHalfFirst19,
  cardQuarter19: cardQuarter19,
  cardPreview19: cardPreview19,
  card20: card20,
  cardHalf20: cardHalf20,
  cardHalfFirst20: cardHalfFirst20,
  cardQuarter20: cardQuarter20,
  cardPreview20: cardPreview20,
  card21: card21,
  cardHalf21: cardHalf21,
  cardHalfFirst21: cardHalfFirst21,
  cardQuarter21: cardQuarter21,
  cardPreview21: cardPreview21,
  card22: card22,
  cardHalf22: cardHalf22,
  cardHalfFirst22: cardHalfFirst22,
  cardQuarter22: cardQuarter22,
  cardPreview22: cardPreview22,
  card23: card23,
  cardHalf23: cardHalf23,
  cardHalfFirst23: cardHalfFirst23,
  cardQuarter23: cardQuarter23,
  cardPreview23: cardPreview23,
  card24: card24,
  cardHalf24: cardHalf24,
  cardHalfFirst24: cardHalfFirst24,
  cardQuarter24: cardQuarter24,
  cardPreview24: cardPreview24,
  card25: card25,
  cardHalf25: cardHalf25,
  cardHalfFirst25: cardHalfFirst25,
  cardQuarter25: cardQuarter25,
  cardPreview25: cardPreview25,
  card26: card26,
  cardHalf26: cardHalf26,
  cardHalfFirst26: cardHalfFirst26,
  cardQuarter26: cardQuarter26,
  cardPreview26: cardPreview26,
  card27: card27,
  cardHalf27: cardHalf27,
  cardHalfFirst27: cardHalfFirst27,
  cardQuarter27: cardQuarter27,
  cardPreview27: cardPreview27,
  card28: card28,
  cardHalf28: cardHalf28,
  cardHalfFirst28: cardHalfFirst28,
  cardQuarter28: cardQuarter28,
  cardPreview28: cardPreview28,
  card29: card29,
  cardHalf29: cardHalf29,
  cardHalfFirst29: cardHalfFirst29,
  cardQuarter29: cardQuarter29,
  cardPreview29: cardPreview29,
  card30: card30,
  cardHalf30: cardHalf30,
  cardHalfFirst30: cardHalfFirst30,
  cardQuarter30: cardQuarter30,
  cardPreview30: cardPreview30,
  card31: card31,
  cardHalf31: cardHalf31,
  cardHalfFirst31: cardHalfFirst31,
  cardQuarter31: cardQuarter31,
  cardPreview31: cardPreview31,
  card32: card32,
  cardHalf32: cardHalf32,
  cardHalfFirst32: cardHalfFirst32,
  cardQuarter32: cardQuarter32,
  cardPreview32: cardPreview32,
  card33: card33,
  cardHalf33: cardHalf33,
  cardHalfFirst33: cardHalfFirst33,
  cardQuarter33: cardQuarter33,
  cardPreview33: cardPreview33,
  card34: card34,
  cardHalf34: cardHalf34,
  cardHalfFirst34: cardHalfFirst34,
  cardQuarter34: cardQuarter34,
  cardPreview34: cardPreview34,
  card35: card35,
  cardHalf35: cardHalf35,
  cardHalfFirst35: cardHalfFirst35,
  cardQuarter35: cardQuarter35,
  cardPreview35: cardPreview35,
  card36: card36,
  cardHalf36: cardHalf36,
  cardHalfFirst36: cardHalfFirst36,
  cardQuarter36: cardQuarter36,
  cardPreview36: cardPreview36,
  card37: card37,
  cardHalf37: cardHalf37,
  cardHalfFirst37: cardHalfFirst37,
  cardQuarter37: cardQuarter37,
  cardPreview37: cardPreview37,
  card38: card38,
  cardHalf38: cardHalf38,
  cardHalfFirst38: cardHalfFirst38,
  cardQuarter38: cardQuarter38,
  cardPreview38: cardPreview38,
  card39: card39,
  cardHalf39: cardHalf39,
  cardHalfFirst39: cardHalfFirst39,
  cardQuarter39: cardQuarter39,
  cardPreview39: cardPreview39,
  card40: card40,
  cardHalf40: cardHalf40,
  cardHalfFirst40: cardHalfFirst40,
  cardQuarter40: cardQuarter40,
  cardPreview40: cardPreview40,
  card41: card41,
  cardHalf41: cardHalf41,
  cardHalfFirst41: cardHalfFirst41,
  cardQuarter41: cardQuarter41,
  cardPreview41: cardPreview41,
  card42: card42,
  cardHalf42: cardHalf42,
  cardHalfFirst42: cardHalfFirst42,
  cardQuarter42: cardQuarter42,
  cardPreview42: cardPreview42,
  card43: card43,
  cardHalf43: cardHalf43,
  cardHalfFirst43: cardHalfFirst43,
  cardQuarter43: cardQuarter43,
  cardPreview43: cardPreview43,
  card44: card44,
  cardHalf44: cardHalf44,
  cardHalfFirst44: cardHalfFirst44,
  cardQuarter44: cardQuarter44,
  cardPreview44: cardPreview44,
  card45: card45,
  cardHalf45: cardHalf45,
  cardHalfFirst45: cardHalfFirst45,
  cardQuarter45: cardQuarter45,
  cardPreview45: cardPreview45,
  card46: card46,
  cardHalf46: cardHalf46,
  cardHalfFirst46: cardHalfFirst46,
  cardQuarter46: cardQuarter46,
  cardPreview46: cardPreview46,
  card47: card47,
  cardHalf47: cardHalf47,
  cardHalfFirst47: cardHalfFirst47,
  cardQuarter47: cardQuarter47,
  cardPreview47: cardPreview47,
  card48: card48,
  cardHalf48: cardHalf48,
  cardHalfFirst48: cardHalfFirst48,
  cardQuarter48: cardQuarter48,
  cardPreview48: cardPreview48,
  card49: card49,
  cardHalf49: cardHalf49,
  cardHalfFirst49: cardHalfFirst49,
  cardQuarter49: cardQuarter49,
  cardPreview49: cardPreview49,
  card50: card50,
  cardHalf50: cardHalf50,
  cardHalfFirst50: cardHalfFirst50,
  cardQuarter50: cardQuarter50,
  cardPreview50: cardPreview50,
  card51: card51,
  cardHalf51: cardHalf51,
  cardHalfFirst51: cardHalfFirst51,
  cardQuarter51: cardQuarter51,
  cardPreview51: cardPreview51,
  card52: card52,
  cardHalf52: cardHalf52,
  cardHalfFirst52: cardHalfFirst52,
  cardQuarter52: cardQuarter52,
  cardPreview52: cardPreview52,

  cardUnknown: cardUnknown,
  cardHalfUnknown: cardHalfUnknown,
  cardHalfFirstUnknown: cardHalfFirstUnknown,
  cardQuarterUnknown: cardQuarterUnknown,
  cardPreviewUnknown: cardPreviewUnknown,

  cardEmpty: cardEmpty
};

const RoomType = {
  POKERSTARS: "Pokerstars",
  FULLTILT: "FullTilt",
  EVEREST_BETCLIC_FR: "Everest/Betclic",
  PARTYGAMING: "Partygaming",
  WINAMAX: "Winamax",
  IGAMING: "Igaming",
  ONGAME: "Ongame",
  BARRIERE: "Barriere",
  PARTOUCHE: "Partouche",
  CAKE_POKER: "Cake",
  MERGE_POKER: "Merge Poker",
  BODOG_POKER: "Bodog",
  NETWORK_888: "888 Network",
  PEOPLES_NETWORK: "Peoples Poker",
  GGPOKER: "GGPoker"
};

const RoomTypeIcons = {
  POKERSTARS: pokerstarsIcon,
  FULLTILT: fulltiltIcon,
  EVEREST_BETCLIC_FR: everestIcon,
  PARTYGAMING: partygamingIcon,
  WINAMAX: winamaxIcon,
  IGAMING: igamingIcon,
  ONGAME: ongameIcon,
  BARRIERE: barriereIcon,
  PARTOUCHE: partoucheIcon,
  CAKE_POKER: cakePokerIcon,
  NETWORK_888: network888Icon,
  PEOPLES_NETWORK: peoplesNetworkIcon,
  GGPOKER: ggPokerIcon
};

const EmotIcons = {
  VOTE0: vote0Icon,
  VOTE0DISABLED: vote0IconDisabled,
  VOTE1: vote1Icon,
  VOTE1DISABLED: vote1IconDisabled,
  VOTE2: vote2Icon,
  VOTE2DISABLED: vote2IconDisabled,
  VOTE3: vote3Icon,
  VOTE3DISABLED: vote3IconDisabled,
  VOTE4: vote4Icon,
  VOTE4DISABLED: vote4IconDisabled
};

const Avatars = {
  avatarA: avatarA,
  avatarZ: avatarZ,
  avatarE: avatarE,
  avatarR: avatarR,
  avatarT: avatarT,
  avatarY: avatarY,
  avatarU: avatarU,
  avatarI: avatarI,
  avatarO: avatarO,
  avatarP: avatarP,
  avatarQ: avatarQ,
  avatarS: avatarS,
  avatarD: avatarD,
  avatarF: avatarF,
  avatarG: avatarG,
  avatarH: avatarH,
  avatarJ: avatarJ,
  avatarK: avatarK,
  avatarL: avatarL,
  avatarM: avatarM,
  avatarW: avatarW,
  avatarX: avatarX,
  avatarC: avatarC,
  avatarV: avatarV,
  avatarB: avatarB,
  avatarN: avatarN
};

const ReplayerMode = {
  SOFTWARE: "SOFTWARE",
  EMBEDDED: "EMBEDDED",
  CODE: "CODE",
  APP: "APP",
  APP_STANDALONE: "APP_STANDALONE"
};

const languages = ["en", "fr", "it", "pt"];
const languageIcons = {
  en: languageEN,
  fr: languageFR,
  it: languageIT,
  pt: languagePT
};
const languageNames = {
  en: "English",
  fr: "Français",
  it: "Italiano",
  pt: "Português"
};

const SearchType = {
  all: "all",
  viewed: "viewed",
  commented: "commented",
  voted: "voted",
  vote1: "vote1",
  vote2: "vote2",
  vote3: "vote3",
  vote4: "vote4"
};

function nFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return +(Math.round(num + "e+2") + "e-2");
}

const handSlug = (hand) => {
  if (RoomType[hand.roomType] !== undefined) {
    return (
      slug(RoomType[hand.roomType]) +
      "-" +
      slug(hand.sessionName) +
      "-" +
      slug(hand.user_name) +
      "-" +
      slug(
        new Intl.DateTimeFormat("en", {
          year: "numeric",
          month: "numeric",
          day: "2-digit"
        }).format(hand.startDate)
      ) +
      "-" +
      hand.id
    );
  } else {
    return "";
  }
};
const slug = (text) => {
  if (text !== undefined) {
    return slugify(text, { delimiter: "-" });
  }
  return "";
};

const CurrencySign = {
  PLAYMONEY: "P",
  FREEROLL: "FREE",
  UNKNOWN: "?",
  FPP: "FPP",
  DOLLAR: "$",
  EURO: "€",
  STERLING: "£",
  YEN: "¥"
}

export {
  languages,
  languageIcons,
  languageNames,
  assets,
  soundValues,
  isDevReact,
  AspectRatio,
  RoomType,
  RoomTypeIcons,
  SessionType,
  GameStructure,
  GameStructureIcons,
  GameSpecialty,
  GameSpecialtyIcons,
  GameVariant,
  GameVariantIcons,
  Step,
  HandEventType,
  Cards,
  getCardText,
  getCardColor,
  ReplayerPreferredSeats,
  ReplayerMode,
  SearchType,
  EmotIcons,
  Avatars,
  CurrencySign,
  nFormatter,
  handSlug,
  slug
};